import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

type GenerateMeetingNotePayload = {
  dataUploadFileId: string;
  templateId?: string;
  agendaFileId?: string;
  meetingDate?: Date;
  summarise?: boolean;
};

type GenerateMeetingNoteResponse = {
  status: string;
  taskId: string;
  meetingNoteId: string;
};

export function useGenerateMeetingNote() {
  const queryClient = useQueryClient();

  const {
    mutateAsync,
    error,
    isPending: isLoading,
    reset,
  } = useMutation<
    { data: GenerateMeetingNoteResponse },
    Error,
    { clientId: string; values: GenerateMeetingNotePayload }
  >({
    mutationFn: ({ clientId, values }: { clientId: string; values: GenerateMeetingNotePayload }) =>
      api.post<GenerateMeetingNoteResponse>(`clients/${clientId}/meeting-notes`, values),
    onSuccess: (_data, { clientId }) => {
      queryClient.invalidateQueries({ queryKey: ['clients', clientId, 'meeting-notes'] });
    },
  });

  const generateMeetingNote = async (clientId: string, values: GenerateMeetingNotePayload) => {
    const result = await mutateAsync({ clientId, values });
    return result.data;
  };

  return {
    generateMeetingNote,
    error,
    isLoading,
    reset,
  };
}
